import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './StatsHeader.module.scss';

const getValue = (value) => {
  if (typeof value === 'string' || typeof value === 'number') {
    return value;
  }
};

const getCamelCase = (string) => {
  return `${string.charAt(0).toLowerCase()}${string.substr(1).replace(/\s/g, '')}`;
};

const Stat = ({ className, title, value }) => (
  <div id={getCamelCase(title)} className={classNames(className, styles.stat)} value={(typeof value === 'object') ? value.map(v => v.symbol) : value}>
    <h1 className={styles.statTitle}>{title}</h1>
    <div className={styles.statValue}>{getValue(value)}</div>
  </div>
);

Stat.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

export default Stat;
